import type { FunctionalComponent } from 'vue'

export const EmailAuthIcon: FunctionalComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <path d="M17.9986 23.1484L27.7812 10.1328L8.21594 10.1328L17.9986 23.1484Z" fill="var(--colors-primary)" />
      <path d="M29 20.8623C29 23.6237 26.7614 25.8623 24 25.8623H18.4521L29 11.8281V20.8623ZM17.5479 25.8623H7V11.8291L17.5479 25.8623Z" fill="var(--colors-bg-button-disabled)" />
    </svg>
  )
}
